"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildHotelRoomSummaries = void 0;
const __1 = require("..");
const getFilteredRoomDiscounts_1 = require("./getFilteredRoomDiscounts");
const buildHotelRoomSummaries = (config) => {
    const currency = config.supplier?.currency || "";
    const grouped_room_summary = config?.rooms?.rooms.map((room) => {
        const applied_discount = (0, getFilteredRoomDiscounts_1.getFilteredRoomDiscounts)(config.date_of_confirmation, config?.where_when_who?.check_in_date, room.applied_discount);
        // Adjustments
        const custom_rate = config?.rooms?.custom || false;
        // Adjustments.  If it's a custom rate, we don't apply the margin discount
        const margin_discount_percentage = custom_rate
            ? 0
            : config?.adjustments?.margin_discount_percentage || 0;
        const price_summary = (0, __1.getRoomRateSummary)(room.rate, room.occupancy, room.extra_bed, margin_discount_percentage, applied_discount);
        return {
            rate_id: room.rate_id,
            currency: currency,
            bed_configuration: room.bed_configuration,
            occupancy: room.occupancy,
            max_occupancy: room.room.max_occupancy,
            nights: room.rate.length,
            view: room.room.view,
            rate_code: [...new Set(room.rate.flatMap((rate) => rate.rate_code))].join(", "),
            summary: `${room.room.name.en} (${(0, __1.occupancyDescription)(room.occupancy)}/${room.board}/${room.bed_configuration.trimEnd()}) - ${room.occupancy} guests`,
            room_type: room.room.name.en,
            room_id: room.room.id,
            board: room.board,
            extra_bed: room.extra_bed,
            guests: room.guests,
            ...Object.fromEntries(Object.entries(price_summary).map(([key, value]) => [
                key,
                typeof value === "number"
                    ? (0, __1.currencyFormatter)(currency, value, false)
                    : value,
            ])),
        };
    });
    return grouped_room_summary;
};
exports.buildHotelRoomSummaries = buildHotelRoomSummaries;
